<div class="container-fluid">
  <si-card class="h-100" data-tour-id="tour-vehicle" [heading]="'VEHICLE.VEHICLE' | translate">
    <div class="card-body mvh-20" body>
      <div class="d-flex flex-column gap-4 h-100 pt-3">
        @if (serviceVehicleError(); as vehicleError) {
          <!-- Display Error message-->
          <si-empty-state
            empty-content
            icon="element-technical-operator"
            [heading]="
              'SHARED.NO_ITEMS_AVAILABLE'
                | translate
                  : {
                      type:
                        ('SHARED.NO_ITEMS_AVAILABLE'
                        | translate: { type: ('VEHICLE.VEHICLES' | translate) })
                    }
            "
            [content]="vehicleError.message"
          />
        } @else {
          <!-- Top Button -->
          <div class="mb-3">
            <button
              type="button"
              class="btn btn-secondary w-30"
              (click)="openModal(selectVehicleModalTemplate)"
            >
              <i class="icon element-database"></i>
              {{ 'SHARED.LOAD' | translate }}
            </button>
          </div>
          @if (selectedVehicle(); as vehicle) {
            @if (vehicle.scenarios.length === 0) {
              <!-- Display Empty message-->
              <div class="h-100 w-100 d-flex align-items-center justify-content-center">
                <si-empty-state
                  empty-content
                  icon="element-technical-operator"
                  [heading]="
                    'SHARED.NO_ITEMS_AVAILABLE'
                      | translate: { type: ('VEHICLE.VEHICLES' | translate) }
                  "
                  [content]="
                    'SHARED.INFO_FAILED_TO_LOAD_DATA'
                      | translate: { type: ('VEHICLE.VEHICLES' | translate) }
                  "
                />
              </div>
            } @else {
              <!-- Title -->
              <div class="row g-8 vehicle-title-row">
                <div class="col d-flex justify-content-between align-items-center">
                  <h3 class="my-0 mb-0">
                    {{ vehicle.name }}
                  </h3>
                </div>
              </div>
              <div class="row g-8">
                <!-- Left Column -->
                <div class="col-12 col-lg-6">
                  <div class="row mb-3">
                    <div class="col-12">
                      <si-form-item label="">
                        <div class="d-flex align-items-center gap-2">
                          <span class="form-label text-secondary mb-0 scenario-label">
                            {{ 'VEHICLE.SCENARIO' | translate }}
                          </span>
                          <button
                            si-help-button
                            type="button"
                            [siHelpTitle]="`${('VEHICLE.SCENARIO' | translate)}s`"
                            [siHelpContent]="popoverTemplate"
                          >
                            <!-- Context for screen readers-->
                            Contextual information about scenarios
                          </button>
                        </div>

                        <select
                          id="scenario-select"
                          aria-label="number"
                          class="form-select"
                          [(ngModel)]="selectedScenario"
                          (ngModelChange)="updateActionsForVehicle()"
                        >
                          @for (scenario of vehicle.scenarios; track $index) {
                            <option [ngValue]="scenario">
                              {{ scenario.name }}
                            </option>
                          }
                        </select>
                      </si-form-item>
                    </div>
                  </div>
                  <div class="row">
                    @if (vehicleNeedsFuelInput()) {
                      <div class="col-6">
                        <si-form-item [label]="fuelInputLabel() | translate">
                          <si-number-input
                            class="form-control"
                            unit="%"
                            [showButtons]="true"
                            [min]="0"
                            [max]="100"
                            [(ngModel)]="selectedAvailableFuel"
                          />
                        </si-form-item>
                      </div>
                    }

                    <div
                      [class.col-6]="vehicleNeedsFuelInput()"
                      [class.col-12]="!vehicleNeedsFuelInput()"
                    >
                      <si-form-item [label]="'VEHICLE.DRIVING_STYLE' | translate">
                        <select
                          aria-label="number"
                          class="form-select"
                          [(ngModel)]="selectedDrivingStyle"
                        >
                          @for (drivingStyle of drivingStyles; track $index) {
                            <option [value]="drivingStyle.value">
                              {{ drivingStyle.name | translate }}
                            </option>
                          }
                        </select>
                      </si-form-item>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-6">
                  <div class="d-flex align-items-center">
                    <si-form-item [label]="'VEHICLE.CONDITIONS' | translate" />
                    <button
                      type="button"
                      class="btn btn-link text-truncate ms-auto"
                      (click)="openVehicleInfo(vehicleInfoModalTemplate)"
                    >
                      <span> Details </span>
                    </button>
                  </div>
                  @if (selectedScenario()) {
                    <ngx-datatable
                      class="table-element text-break"
                      rowHeight="auto"
                      columnMode="flex"
                      [rows]="[selectedScenario()?.description]"
                      [footerHeight]="0"
                    >
                      <ngx-datatable-column
                        prop="description"
                        [name]="'VEHICLE.DESCRIPTION' | translate"
                        [flexGrow]="3"
                        [resizeable]="false"
                        [sortable]="false"
                      />

                      <ngx-datatable-column
                        prop="wind"
                        [name]="'VEHICLE.WIND' | translate"
                        [flexGrow]="3"
                        [resizeable]="false"
                        [sortable]="false"
                      />
                      <ngx-datatable-column
                        prop="temperature"
                        [name]="'VEHICLE.TEMPERATURE' | translate"
                        [flexGrow]="3"
                        [resizeable]="false"
                        [sortable]="false"
                      />

                      <ngx-datatable-column
                        prop="life"
                        name="Life"
                        [flexGrow]="2"
                        [resizeable]="false"
                        [sortable]="false"
                      />
                    </ngx-datatable>
                  }
                </div>
              </div>
            }
          } @else {
            <div class="d-flex justify-content-center align-items-center flex-grow-1">
              {{ 'SHARED.INFO_LOAD' | translate: { type: ('VEHICLE.VEHICLE' | translate) } }}
            </div>
          }
        }
      </div>
    </div>
  </si-card>
</div>

<ng-template #selectVehicleModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">
      {{ 'LOAD_MODAL.HEADING' | translate: { type: ('VEHICLE.VEHICLE' | translate) } }}
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <app-load-modal
      class="h-100"
      mode="vehicle"
      dataType="vehicle"
      (openItemClicked)="this.closeModal(modalRef); openVehicleClicked($event)"
    />
  </div>
</ng-template>

<!-- Vehicle Info Modal Template -->
<ng-template #vehicleInfoModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title my-0">
      {{ selectedVehicle()?.name }} - {{ 'VEHICLE.VEHICLE' | translate }} Info
    </h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    @if (scenarioParametersLoading()) {
      <div class="d-flex justify-content-center align-items-center p-6">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else if (scenarioParameters()) {
      <p class="mb-4 text-secondary">
        Scenario: <strong>{{ selectedScenario()?.name }}</strong>
      </p>

      @for (section of scenarioParameterSections(); track section.heading) {
        <div class="card mb-4">
          <div class="card-header">
            <strong>{{ section.heading }}</strong>
          </div>
          <div class="card-body p-0">
            <ngx-datatable
              class="table-element text-break"
              columnMode="flex"
              [rowHeight]="tableConfig.rowHeightSmall"
              [rows]="section.params"
              [footerHeight]="0"
              [headerHeight]="0"
            >
              <ngx-datatable-column
                prop="key"
                [flexGrow]="5"
                [resizeable]="false"
                [sortable]="false"
              />
              <ngx-datatable-column
                prop="value"
                [flexGrow]="3"
                [resizeable]="false"
                [sortable]="false"
              />
            </ngx-datatable>
          </div>
        </div>
      }
    } @else {
      <si-empty-state
        icon="element-technical-operator"
        heading="No data available"
        content="Could not load scenario parameters."
      />
    }
  </div>
</ng-template>

<ng-template #popoverTemplate>
  <si-popover-body>
    <ul class="ps-3">
      <li>{{ 'VEHICLE.SCENARIO_TOOLTIP_NORMALLOAD' | translate }}</li>
      <li>{{ 'VEHICLE.SCENARIO_TOOLTIP_HIGHLOAD' | translate }}</li>
      <br />
      <li
        >{{ 'VEHICLE.SCENARIO_TOOLTIP_BOL' | translate }} <br />
        {{ 'VEHICLE.SCENARIO_TOOLTIP_BOL_DESCRIPTION' | translate }}</li
      >
      <li
        >{{ 'VEHICLE.SCENARIO_TOOLTIP_MOL' | translate }} <br />
        {{ 'VEHICLE.SCENARIO_TOOLTIP_MOL_DESCRIPTION' | translate }}</li
      >
      <li>
        {{ 'VEHICLE.SCENARIO_TOOLTIP_EOL' | translate }} <br />
        {{ 'VEHICLE.SCENARIO_TOOLTIP_EOL_DESCRIPTION' | translate }}</li
      >
    </ul>
  </si-popover-body>
</ng-template>
